module.exports = __webpack_public_path__ + "static/media/9.fe5e48c1.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/9.wav
// module id = 37
// module chunks = 0